<template>
    <div :class="[isRead ? 'choice' : 'choices']">
      <div class="leftChoice">
        <p class="tp" v-html="topicData ? topicData.topic.title : ''"></p>
        <!-- <p
          class="bo"
          v-html="topicData ? topicData.topic.stem : ''"
          v-if="show"
        ></p> -->
      </div>
      <!-- <div class="leftChoice" v-show="topicData && topicData.topic.title.indexOf('str') != -1" v-html="topicData ? topicData.topic.title : ''"></div> -->
  
      <div class="rightChoice">
        <div class="tiGan" v-show="topicData && topicData.topic.stem.indexOf('str') != -1" style="margin: 20px 0 15px 0"
          v-html="
            topicData && topicData.topic.stem
              ? topicData.topic.stem.replace(/\n/g, '<br>')
              : ''
          "></div>
        <div class="choiceT">
          <el-radio-group v-model="radio" @change="radioChange">
            <el-radio :label="ele.value" v-for="(ele, index) in singleChoice" :key="index" style="display: flex">
              <div v-html="ele.name.replace(/\n/g, '<br>')"></div>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="height: 32px; background: white"></div>
    </div>
  </template>
  
  <script>
    import api from "@/api/dryRun.js";
    export default {
      updated() {
        let $ps = $(".leftChoice>p>span");
        $ps.css({
          fontFamily: "微软雅黑",
          "line-height": "25px",
          "font-size": "14px !important",
        });
      },
      data() {
        return {
          radio: "",
          singleChoice: [],
          topicData: null,
          //阅读控制
          isRead: true,
          isshow: "",
          show: true,
        };
      },
      watch: {
        radio(val, vals) {
          console.log(val, vals);
          sessionStorage.setItem("answer", JSON.stringify([val.toString()]));
          if (val !== "") {
            sessionStorage.setItem("isAnswer", true);
          } else {
            sessionStorage.setItem("isAnswer", false);
          }
        },
      },
      async created() {
        if (sessionStorage.getItem("examType") === "练习") {
          if (sessionStorage.getItem("isFirst") === "true") {
            this.startExercise();
          } else {
            this.nextExerciseTopic();
          }
        } else {
          if (sessionStorage.getItem("review") === "true") {
            this.getMockexam();
          } else if (sessionStorage.getItem("isFirst") === "true") {
            this.startAnswer();
          } else {
            let params = {
              id: sessionStorage.getItem("curId"),
              m_id: sessionStorage.getItem("m_id"),
            };
            const res = await api.next(params);
            console.log("新的题目", res);
            if (res.data.code === 0) {
              this.topicData = res.data.data;
              const isRead = res.data.data.topic.c_id;
              if (isRead == 9) {
                this.isRead = false;
              }
              let nums = this.topicData.index;
              const q_id = this.topicData.topic.id;
              if (this.topicData.sortlist) {
                for (const item of this.topicData.sortlist) {
                  if (item.indexOf(q_id) > -1) {
                    nums = item.indexOf(q_id) + 1;
                  }
                }
              }
              sessionStorage.setItem('mark', this.topicData.mark);
              sessionStorage.setItem("q_id", q_id);
              sessionStorage.setItem("collect", this.topicData.topic.collect);
              sessionStorage.setItem("nums", nums);
              document.getElementById("i").innerHTML =
                sessionStorage.getItem("nums");
              sessionStorage.setItem("topicCount", this.topicData.topicCount);
              document.getElementById("count").innerHTML =
                sessionStorage.getItem("topicCount");
              sessionStorage.setItem("topicCType", this.topicData.topicCType);
              sessionStorage.setItem(
                "choice",
                JSON.stringify(this.topicData.choice)
              );
              this.$emit('changeReview')
              this.singleChoice = this.topicData.topic.answer.map((item, index) => {
                return {
                  value: index,
                  name: item,
                };
              });
            } else {
              this.$message.error(res.data.msg);
            }
          }
        }
      },
      methods: {
        async nextExerciseTopic() {
          let params = {
            id: sessionStorage.getItem("curId"),
            m_id: sessionStorage.getItem("m_id"),
          };
          const res = await api.nextExercise(params);
          console.log("下一道练习题", res);
          if (res.data.data.topic.stem == "") {
            console.log(111);
            this.show = false;
          } else {
            console.log(222);
            this.show = true;
          }
          if (res.data.code === 0) {
            this.topicData = res.data.data;
            console.log(this.topicData, "内容");
            const isRead = res.data.data.c_id;
            if (isRead == 9) {
              this.isRead = false;
            }
            let nums = this.topicData.index;
            const q_id = this.topicData.topic.id;
            if (this.topicData.sortlist) {
              for (const item of this.topicData.sortlist) {
                if (item.indexOf(q_id) > -1) {
                  nums = item.indexOf(q_id) + 1;
                }
              }
            }
            sessionStorage.setItem("q_id", q_id);
            sessionStorage.setItem("collect", this.topicData.topic.collect);
            sessionStorage.setItem("nums", nums);
            document.getElementById("i").innerHTML = sessionStorage.getItem("nums");
            sessionStorage.setItem("topicCount", this.topicData.topicCount);
            sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
            document.getElementById("count").innerHTML =
              sessionStorage.getItem("topicCount");
            this.singleChoice = this.topicData.topic.answer.map((item, index) => {
              return {
                value: index,
                name: item,
              };
            });
          } else {
            this.$message.error(res.data.msg);
          }
        },
        // 获取练习题数据
        async startExercise() {
          const res = await api.startExercise({
            m_id: sessionStorage.getItem("m_id"),
          });
          console.log("练习题数据", res);
          //阅读分栏
          //判断是否是阅读题
          const read = res.data.data.c_id;
          if (read == 9) {
            console.log("这是阅读题");
            this.isRead = false;
          }
          if (res.data.code === 0) {
            this.topicData = res.data.data;
            console.log(this.topicData);
            sessionStorage.setItem("q_id", this.topicData.topic.id);
            sessionStorage.setItem("collect", this.topicData.topic.collect);
            sessionStorage.setItem("curId", this.topicData.examnumber);
            sessionStorage.setItem("topicCount", this.topicData.topicCount);
            document.getElementById("count").innerHTML =
              sessionStorage.getItem("topicCount");
            sessionStorage.setItem("isFirst", false);
            sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
            this.singleChoice = this.topicData.topic.answer.map((item, index) => {
              return {
                value: index,
                name: item,
              };
            });
          } else {
            this.$message.error("获取练习题数据失败！");
          }
        },
        async getMockexam(){
          let startParams = {
            id: sessionStorage.getItem("curId"),
            m_id: sessionStorage.getItem("m_id"),
            q_id: sessionStorage.getItem("q_id"),
          };
          const res = await api.getMockexam(startParams);
          if (res.data.code === 0) {
            this.topicData = res.data.data;
            let nums = this.topicData.index;
            const q_id = this.topicData.topic.id;
            if (this.topicData.sortlist) {
              for (const item of this.topicData.sortlist) {
                if (item.indexOf(q_id) > -1) {
                  nums = item.indexOf(q_id) + 1;
                }
              }
            }
            sessionStorage.setItem("q_id", q_id);
            sessionStorage.setItem('mark', this.topicData.mark);
            sessionStorage.setItem("collect", this.topicData.topic.collect);
            sessionStorage.setItem("nums", nums);
            sessionStorage.setItem("topicCount", this.topicData.topicCount);
            document.getElementById("count").innerHTML =
              sessionStorage.getItem("topicCount");
            sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
            sessionStorage.setItem("topicCType", this.topicData.topicCType);
            sessionStorage.setItem("isFirst", false);
            console.log(this.topicData.answer);
            if(this.topicData.answer !== '0'){
              this.radio = JSON.parse(this.topicData.answer)[0] * 1
              sessionStorage.setItem("answer", JSON.stringify([this.topicData.answer.toString()]));
              sessionStorage.setItem("isAnswer", true);
            }
            this.$emit('changeReview')
            this.singleChoice = this.topicData.topic.answer.map((item, index) => {
              return {
                value: index,
                name: item,
              };
            });
          }
        },
        // 该题是第一题是执行这个方法
        async startAnswer() {
          let startParams = {
            m_id: sessionStorage.getItem("m_id"),
            // m_id:this.$route.params.id,
            id: this.$route.query.id,
          };
          const res = await api.startMockExam(startParams);
          console.log("此题是第一题", res);
          if (res.data.code === 0) {
            this.topicData = res.data.data;
            let nums = this.topicData.index;
            const q_id = this.topicData.topic.id;
            if (this.topicData.sortlist) {
              for (const item of this.topicData.sortlist) {
                if (item.indexOf(q_id) > -1) {
                  nums = item.indexOf(q_id) + 1;
                }
              }
            }
            sessionStorage.setItem("q_id", q_id);
            sessionStorage.setItem("collect", this.topicData.topic.collect);
            sessionStorage.setItem("nums", nums);
            sessionStorage.setItem("topicCount", this.topicData.topicCount);
            document.getElementById("count").innerHTML =
              sessionStorage.getItem("topicCount");
            sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
            sessionStorage.setItem("topicCType", this.topicData.topicCType);
            sessionStorage.setItem("isFirst", false);
            if(this.topicData.answer !== 0){
              this.radio = this.topicData.answer
            }
            this.singleChoice = this.topicData.topic.answer.map((item, index) => {
              return {
                value: index,
                name: item,
              };
            });
          }
        },
        radioChange() {
          console.log(this.radio);
        },
      },
    };
  
  </script>
  
  <style scoped>
    @import "../../assets/css/singleChoice.css";
  
    .tiGan {
      display: block !important;
    }
  
    div>>>.el-radio__input.is-checked+.el-radio__label {
      color: black;
    }
  
  </style>
  


// WEBPACK FOOTER //
// src/view/examinatSystem/selection.vue